import request from "@assets/js/axios";
const { instance: $axios } = request;
class Address {
  constructor() {}
  list () {
    return $axios.get('/api/v1/address/byUserId');
  }
  change (id, data, _method = 'PUT') {
    return $axios.post('/api/v1/address/'+id, { ...data, id, _method } )
  }
  add (data) {
    return $axios.post('/api/v1/address/store', data);
  }
}

export default new Address();